var map = {
	"./de.json": 11394,
	"./en.json": 13451,
	"@freshsolutions/fresh-vue-audits/src/locale/de.json": 11394,
	"@freshsolutions/fresh-vue-audits/src/locale/en.json": 13451
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45802;